export default "__VITE_PUBLIC_ASSET__a515167f__"